/**
 * @copyright 汽车商贸管理平台 V1.0
 * @year 2026
 * @file main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import api from './api/index'
import tools from './utils/tools.js'

import Vant from 'vant';  
import 'vant/lib/index.css'; 

import ElementUI from 'element-ui'  
import 'element-ui/lib/theme-chalk/index.css'  
import JsonExcel from 'vue-json-excel'

//在手机端显示vConsole蓝色按钮，用于在手机端查看控制台调试
import Vconsole from 'vconsole';
// 仅在开发环境下初始化 vConsole
if (process.env.NODE_ENV === 'development') {
  new Vconsole()
}

Vue.component('downloadExcel', JsonExcel)
  
Vue.use(ElementUI)


// 从 localStorage 获取 token  
const token = localStorage.getItem('token'); 
  
// 如果存在 token，则设置到 Vuex 中  
if (token) {  
  store.state.token = token; // 直接设置到 state，避免不必要的 mutation 调用  
}
  
Vue.use(Vant);  
//Vue.prototype.$api=api
Vue.prototype.$tools=tools
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
